module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/file-image-f8d28c3e5758f224a7605f5ad41e39e6.svg";